// search suggestion
document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("search-input");
    const searchResult = document.getElementById("search-results");
    const suggestionWrapper = document.querySelector(".collection-search-suggestion-wrapper");

    function toggleSearchContent() {
        const keyword = searchInput.value.trim();

        if (keyword.length > 0) {
            searchResult.style.display = "block";
            if (suggestionWrapper) {
                suggestionWrapper.style.display = "none";
            }
        } else {
            searchResult.style.display = "none";

            if (suggestionWrapper) {
                suggestionWrapper.style.display = "block"
            }
        }
    }

    toggleSearchContent();


    searchInput.addEventListener("input", toggleSearchContent)
})